import installGlassV3 from './glassV3Engine';
import { GLASS_MODE, GLASS_SETTINGS } from './glassSettings';

/**
 * ensureGlassV3: installs the final Aero glass engine once, on first use, and
 * returns its API (window.GlassV3): GlassV3(el), .init(root), .refresh(),
 * .release(el). Returns null outside a browser.
 *
 * The engine reads its numbers from window.GLASS_P, exactly as on the
 * website, so it is fed from the single settings module here.
 */
export function ensureGlassV3() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null;
  if (window.GlassV3 && window.GlassV3.release) return window.GlassV3;
  window.GLASS_P = { ...GLASS_SETTINGS };
  window.GLASS_MODE = GLASS_MODE;
  window.GLASS_BTN_CLASS = '.aero-g3';
  // The app's own button CSS (xs size, loader) reads the same radius and
  // frost inset as the engine, so they come from the settings too.
  const root = document.documentElement.style;
  root.setProperty('--aero-glass-radius', `${GLASS_SETTINGS.radius}px`);
  root.setProperty('--aero-glass-frost-inset', `${GLASS_SETTINGS.frostInset}px`);
  installGlassV3(window, document);
  return window.GlassV3 || null;
}

/**
 * applyGlassSettings: swap the glass look at runtime (the glass panel does
 * this on the website). Not used by the app today; kept for the showcase.
 */
export function applyGlassSettings(next) {
  const api = ensureGlassV3();
  if (!api) return;
  window.GLASS_P = { ...window.GLASS_P, ...next };
  window.GLASS_P_V = (window.GLASS_P_V || 0) + 1;
  api.refresh();
}

export { GLASS_SETTINGS, GLASS_MODE };
